import {Component, Inject, Input, OnInit, PLATFORM_ID} from '@angular/core';
import {GetBankAccountListAction} from './get-bank-account-list.action';
import {DataManagerService} from '../../data/services/DataManager/data-manager.service';
import {ApiAccessToken, ApiResponseModel} from '../../data/model/ApiResponseModel/api-response.model';
import {WebhookLogModel} from '../../data/model/WebhookLogModel/webhook_log.model';
import {BankAccountModel} from '../../data/model/BankAccountModel/bank-account.model';
import {ActivatedRoute, Router} from '@angular/router';
import {MatSnackBar} from '@angular/material/snack-bar';
import {debounceTime} from 'rxjs/operators';
import {ErrorConstants} from '../../shared/constants/error-constants';
import {AppConstants} from '../../shared/constants/app-constants';
import {DatePipe, isPlatformBrowser} from '@angular/common';
import {PermissionConstants} from '../../shared/constants/permission-constants';
import {MatDialog, MatDialogConfig} from '@angular/material/dialog';
import {SubscriptionComponent} from '../../subscriptionModule/subscription/subscription.component';
import {Subject, Subscription} from 'rxjs';
import {Highlight} from '../../shared/highlights/highlight';
import {ApiTokenComponent} from '../../dialogs/api-token/api-token.component';
import {ChangeRequestDialogComponent} from '../../dialogs/change-request-dialog/change-request-dialog.components';

@Component({
    selector: 'app-bank-account-list',
    templateUrl: './bank-account-list.component.html',
    styleUrls: ['./bank-account-list.component.css'],
    standalone: false
})
export class BankAccountListComponent extends GetBankAccountListAction implements OnInit {
  dataManager: DataManagerService;
  runActionDialog: Subscription;
  bankAccountList: ApiResponseModel<BankAccountModel>;
  _service_name = '/merchant_bank_accounts';
  @Input() AccountData: any;
  constructor(
    route: ActivatedRoute,
    private dialog: MatDialog,
    router: Router,
    dataManager: DataManagerService,
    snackBar: MatSnackBar,
    @Inject('LOCALSTORAGE') private localStorage: any, private datePipe: DatePipe,
    @Inject(PLATFORM_ID) private platformId: any
  ) {
    super();
    this.dataManager = dataManager;
    this.snackBar = snackBar;
    this.searchHits = new Subject<void>();
    this.alertDialog = dialog;
    this.errorMsg = null;
    this.route = route;
    this.router = router;
    this.bankAccountList = new ApiResponseModel<BankAccountModel>();
    this.getListUrl = AppConstants.BASE_URL + this._service_name;
  }
    ngOnInit(): void {
      if (isPlatformBrowser(this.platformId)) {
        if (
          !this.localStorage.getItem(this.filter_storage_key) &&
          !this.localStorage.getItem(this.count_storage_key)
        ) {
          this.setUrl();
        }
      }
  }
  highlight(value) {
    return Highlight.highlight(value, this.searchText);
  }
  limitChange() {
    this.setUrl();
  }
  protected getListErr(err) {
    this.errorMsg = this.networkErrorHandler(err.error, ErrorConstants.bankAccountsErrorMsg);

  }

  protected getListRes(bankAccountListResponse: ApiResponseModel<BankAccountModel>) {
    this.bankAccountList = bankAccountListResponse;
    this.metadata = bankAccountListResponse.meta.pagination;
    if (this.bankAccountList.data.length === 0) {
      this.errorMsg = ErrorConstants.bankAccountsErrorMsg[0];
    } else {
      this.errorMsg = null;
    }
  }
  paginate(paginateExtension) {
    this.getList(paginateExtension);
  }
  openHistory() {
    this.router.navigateByUrl('/merchant/branding/change-request-history');
  }

  changeBankAccount() {
    console.log('Account Data', this.AccountData);
    const dialogConfig = new MatDialogConfig();
    dialogConfig.panelClass = 'change-request-modal';
    dialogConfig.width = '1000px';
    // dialogConfig.height = '560px';
    dialogConfig.disableClose = true;
    dialogConfig.data = {
      legal_name: this.AccountData.account_name,
      ein: this.AccountData.tax_id,
      account_id: this.AccountData.id
    };
    this.runActionDialog = this.alertDialog.open(ChangeRequestDialogComponent, dialogConfig)
      .afterClosed().subscribe(
        res => {
          if (res === 'run') {
            this.getList(this.setUrl());
          }
        }
      );
  }
}
